import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { AuthService } from 'app/services/auth.services'
import { RestServices } from 'app/services/rest.services'
import { ModalService } from 'app/services/modal.service'
import { SharedServices } from 'app/services/shared.services'
import { FormBuilder } from '@angular/forms'
import * as moment from 'moment'
import { notification } from 'onsenui'
import { MatrixServices } from 'app/services/image/matrix.services'
import { getImageStatusUrl, getThumbnail, imageUrl } from '@helpers/common'
import { compact } from 'lodash'
import { Subscription } from 'rxjs'
import { NotificationService } from '@app/services/notification.service'

@Component({
    selector: 'app-modal-communication-client-detail',
    templateUrl: './modal-communication-client-detail.component.html',
    styleUrls: [
        '../../../../stagingcss/root-ui-view.component.css',
        '../../../../stagingcss/ui-schema-table-form.component.css',
        './modal-communication-client-detail.component.css',
        '../../../../stagingcss/image-viewer.component.css',
        '../../../../stagingcss/radial-progress.component.css',
    ],
    providers: [MatrixServices]
})

export class ModalCommunicationClientDetailComponent implements OnInit, AfterViewInit, OnDestroy {
    clientId
    clinic
    imageUrl = imageUrl
    en = {}
    showEN = true
    showEditMessage = 'hidden'
    createDate
    showDate1
    timestampDate
    timestampDateDb
    showDate

    hiddenModalUser = 'hidden'
    hiddenModalUserStaff = 'hidden'
    showOption: any
    filterLang: string
    showOptionStaff: any
    filterStaff: string
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    arrUser
    arrStaff
    valueCreator
    valueCreatorDeleted
    valueStaff
    valueStaffDeleted
    styleVisibility: any
    styleVisibilityStaff: any
    optionArrCopy
    noteMessage
    // nextMessage
    creatorId
    StaffId
    idRoom
    // image modal
    showNewImage = 'hidden'
    showNewPdf = 'hidden'
    statusImage = false
    statusPdf = false
    url
    arrImage = []
    arrPdf = []
    arrImageHash = []
    arrPdfHash = []
    hiddeniconAddImage = true
    hiddeniconAddPdf = true
    displayRemoveImage = true
    displayRemovePdf = true

    // edit message
    statusSave
    arrclientId
    idUpdateTimeline
    statusReadonly

    // movies modal
    showNewVideo = 'hidden'
    statusVideo = false
    faceVideo
    arrVideo = []
    arrstatusVideo = []
    arrVideoHash = []
    displayRemoveVideo = true
    pauseVideo = true

    // image
    arrStyleImage = []
    arrRotate = []
    horizontalFlip = 1
    verticalFlip = 1
    arrFlip = []
    arrLoading = []
    loading = false
    statusShowImage = []
    statusShowPdf = []
    animationDuration
    hiddenModalImage = 'hidden'
    urlBigImage
    styleReponsiveBigImage
    matrix
    matrixImage = []
    hasBeenLoaded = false
    hasBeenEdited = false
    statusESC = false
    coordinates
    dXdYMatrixCanvas = []
    @ViewChild('inputFile') myInputVariable: ElementRef
    timelineTags = []
    selectedTags = []
    checkHasValidator = false
    showMessage = ''
    distroySubcribeTimeline
    showModal = 0
    urlThumbail = ''
    public readonly TYPE_MODAL_POPUP = {
        MESSAGE: 1,
        IMAGE: 2,
        PDF: 3,
        VIDEO: 4,
        BIGIMAGE: 5,
    }
    private postFileSubs: any = {}
    private subscriptions: Array<Subscription> = []
    isSaveImage = false
    isSavePdf = false
    isSaveVideo = false

    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private modalService: ModalService,
                public matrixServices: MatrixServices,
                public notificationServices: NotificationService,
                public el: ElementRef) {

        this.distroySubcribeTimeline = modalService.changeEmitted$.subscribe(success => {
            this.selectedTags = []
            if (success) {
                if (success[1] === 'showModalMessageDetailCommunication') {
                    this.clean()
                    // this.nextMessage = ''
                    this.noteMessage = ''
                    this.selectedTags = []
                    this.creatorId = ''
                    this.StaffId = ''
                    this.showModal = this.TYPE_MODAL_POPUP.MESSAGE
                    this.idRoom = success[0]
                    this.showEditMessage = 'active'
                    this.hasBeenLoaded = true
                    if (success[3] === 'edit') {
                        this.statusReadonly = true
                        this.statusSave = success[3]
                        this.idUpdateTimeline = success[2]
                        this.getClientId(success[2])
                    } else {
                        this.statusReadonly = false
                    }
                    this.timelineTags = success[4]
                } else if (success[1] === 'showModalImageDetailCommunication') {
                    this.clean()
                    if (this.arrImage.length == 0) {
                        this.resetImageArr()
                    }
                    this.idRoom = success[0]
                    this.showNewImage = 'active'
                    this.hasBeenLoaded = true
                    this.showModal = this.TYPE_MODAL_POPUP.IMAGE
                    if (success[3] === 'edit') {
                        this.statusReadonly = true
                        this.statusSave = success[3]
                        this.idUpdateTimeline = success[2]
                        this.getClientId(success[2])
                    } else {
                        this.statusSave = 'create'
                        this.statusReadonly = false
                        this.resetImageArr()
                    }
                    this.timelineTags = success[4]

                } else if (success[1] === 'showModalPdfDetailCommunication') {
                    this.clean()
                    if (this.arrPdf.length == 0) {
                        this.arrPdf.push('init')
                    }
                    this.idRoom = success[0]
                    this.showNewPdf = 'active'
                    this.hasBeenLoaded = true
                    this.showModal = this.TYPE_MODAL_POPUP.PDF
                    if (success[3] === 'edit') {
                        this.statusReadonly = true
                        this.statusSave = success[3]
                        this.idUpdateTimeline = success[2]
                        this.getClientId(success[2])
                    } else {
                        this.statusReadonly = false
                    }
                    this.timelineTags = success[4]
                } else if (success[1] === 'showModalVideoDetailCommunication') {
                    this.clean()
                    this.idRoom = success[0]
                    this.hasBeenLoaded = true
                    this.showNewVideo = 'active'
                    this.showModal = this.TYPE_MODAL_POPUP.VIDEO
                    if (success[3] === 'edit') {
                        this.statusReadonly = true
                        this.statusSave = success[3]
                        this.idUpdateTimeline = success[2]
                        this.getClientId(success[2])
                    } else {
                        this.statusReadonly = false
                    }
                    this.timelineTags = success[4]
                } else if (success[1] === 'showBigImageDetailCommunication') {
                    this.clean()
                    this.hiddenModalImage = 'active'
                    this.loading = true
                    this.showModal = this.TYPE_MODAL_POPUP.BIGIMAGE
                    setTimeout(() => {
                        this.urlBigImage = success[0]
                        this.loading = false
                        this.matrix = success[2] ? success[2] : [1, 0, 0, 1]
                        // this.items.push(0);
                    }, 500)
                }
            }
        })
        this.clientId = this.authData.getClientId()
        this.clinic = this.authData.getUser()
    }

    ngOnInit() {
        this.resetImageArr()
        this.arrPdf.push('init')
        this.matrixServices.arrStyleImage.push(0)
        this.showDate1 = moment().format('YYYY.MM.DD ddd')
        this.timestampDateDb = moment(Date.now()).utc().startOf('day').valueOf()
        // this.setMatrix();
        // this.arrstatusImage.push(undefined);
    }

    clean() {
        this.postFileSubs = {}
    }

    setMatrix() {
        if (this.arrclientId && this.arrclientId['images']) {
            this.initArrayMatrix(this.arrclientId['images'])
        } else {
            setTimeout(() => {
                this.setMatrix()
                // this.items.push(0);
            }, 200)
        }
    }

    ngOnDestroy() {
        if(this.distroySubcribeTimeline)
            this.distroySubcribeTimeline.unsubscribe()
    }

    // add or remove selected tags
    toggleTag(item) {
        this.markChanged()
        if (this.statusReadonly) {
            return
        }
        const found = this.selectedTags.findIndex((e) => {
            return e == item._id
        })
        if (found == -1) {
            this.selectedTags.push(item._id)
        } else {
            this.selectedTags.splice(found, 1)
        }
    }

    isHaveTag

    // check tag is selected
    checkActiveTag(item) {
        const found = this.selectedTags.findIndex((e) => {
            return e === item._id
        })
        if (found !== -1) {
            return true
        }
        return false
    }

    checkDisableTag(item) {
        const found = this.selectedTags.findIndex((e) => {
            return e === item._id
        })
        if (found == -1 && this.statusReadonly == true) {
            return true
        }
        return false
    }

    ngAfterViewInit(): void {

    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        let keyPressed = event.keyCode
        if (keyPressed === 27) {
            event.preventDefault()
            if (this.statusESC) {
                this.statusESC = false
                this.hiddenModalUser = 'hidden'
                this.hiddenModalUserStaff = 'hidden'
            } else {
                if (this.hasBeenEdited) {
                    this.changeLanguage()
                    notification.confirm({
                        message: this.en['alert-content-discard'],
                        title: '<b>' + this.en['alert-discard'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], 'OK'],
                        callback: i => {
                            if (i === 1) {
                                this.showEditMessage = 'hidden'
                                this.showNewImage = 'hidden'
                                this.showNewPdf = 'hidden'
                                this.showNewVideo = 'hidden'
                                this.resetModel()
                            }
                        },
                    })
                } else {
                    this.showEditMessage = 'hidden'
                    this.showNewImage = 'hidden'
                    this.showNewPdf = 'hidden'
                    this.showNewVideo = 'hidden'
                    this.resetModel()
                }
            }
        }
    }

    // ******************* IMAGE **************************** //
    // loadSizeImage(img, container, i) {
    //     this.matrixServices.loadSizeImage(img, container, i);
    // }

    hiddenModalBigImage() {
        this.hiddenModalImage = 'hidden'
        this.urlBigImage = undefined
    }

    // big Image
    reponsiveImage(sizeImage, widthBigImage, matrixImage) {
        const n1 = (widthBigImage.offsetHeight / sizeImage.clientHeight) * (matrixImage[0]) // n1
        const n2 = (widthBigImage.offsetHeight / sizeImage.clientWidth) * (matrixImage[1]) // n2
        const n3 = (widthBigImage.offsetHeight / sizeImage.clientWidth) * (matrixImage[2]) // n3
        const n4 = (widthBigImage.offsetHeight / sizeImage.clientHeight) * (matrixImage[3]) // n4
        const n5 = (widthBigImage.offsetWidth - sizeImage.clientWidth) / 2
        const n6 = (widthBigImage.offsetHeight - sizeImage.clientHeight) / 2
        this.styleReponsiveBigImage = {
            'transform': 'matrix(' + n1 + ', ' + n2 + ', ' + n3 + ', ' + n4 + ',' + n5 + ',' + n6 + ')',
        }
    }

    showBigImage(id, matrix) {
        const arrImage = [id, 'showBigImage', matrix]
        this._sharedService.emitChange(arrImage)
    }


    // ******************* IMAGE **************************** //

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    hidenModalMessage() {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-discard'],
                title: this.en['alert-discard'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.showEditMessage = 'hidden'
                        this.resetModel()
                    }
                },
            })
        } else {
            this.showEditMessage = 'hidden'
            this.resetModel()
        }
    }

    closeEdit() {
        this.resetModel()
        this.showEditMessage = 'hidden'
        this.showNewImage = 'hidden'
        this.showNewPdf = 'hidden'
        this.showNewVideo = 'hidden'
    }

    hidenModalImage() {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-discard'],
                title: this.en['alert-discard'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.showNewImage = 'hidden'
                        this.resetModel()
                    }
                },
            })
        } else {
            this.resetModel()
            this.showNewImage = 'hidden'
        }
    }

    hidenModalPdf() {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-discard'],
                title: this.en['alert-discard'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.showNewPdf = 'hidden'
                        this.resetModel()
                    }
                },
            })
        } else {
            this.resetModel()
            this.showNewPdf = 'hidden'
        }
    }

    hidenModalVideo() {
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-discard'],
                title: this.en['alert-discard'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.showNewVideo = 'hidden'
                        this.resetModel()
                    }
                },
            })
        } else {
            this.showNewVideo = 'hidden'
            this.resetModel()
        }
    }

    // show theme date
    formatCreateDate(event) {
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        if (event) {
            const setTimestamp = moment(event['_d'])
            setTimestamp.set({ hours: 10 })
            const timestamp = moment(setTimestamp).startOf('day').valueOf()
            this.showDate1 = moment(timestamp).format('YYYY.MM.DD ddd')
            this.timestampDate = timestamp
            this.timestampDateDb = moment(setTimestamp).utc().startOf('day').valueOf()
            this.createDate = moment(timestamp)
        } else {
            const timestamp = moment(Date.now()).utc().startOf('day').valueOf()
            this.showDate1 = moment(Date.now()).format('YYYY.MM.DD ddd')
            this.timestampDateDb = timestamp
        }

    }

    nextDate(timestampAdd, day) {
        this.markChanged()
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).add(day, 'days').startOf('day').valueOf()
        const timestampDateDb = moment(adDate['_d']).utc().add(addTime, 'hours').add(day, 'days').startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        this.timestampDate = timestampDate
        this.timestampDateDb = timestampDateDb
        this.showDate1 = showdateAdd
        this.createDate = moment(timestampDate)
    }

    prevDate(timestampAdd, day) {
        this.markChanged()

        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).subtract(day, 'days').startOf('day').valueOf()
        const timestampDateDb = moment(adDate['_d']).utc().add(addTime, 'hours').subtract(day, 'days').startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        this.timestampDate = timestampDate
        this.timestampDateDb = timestampDateDb
        this.showDate1 = showdateAdd
        this.createDate = moment(timestampDate)
    }

    hidenModal() {
        this.hiddenModalUser = 'hidden'
        this.hiddenModalUserStaff = 'hidden'
        this.statusESC = false
    }

    selectOption(id, value) {
        this.showOption = 'showOption_' + id
        if (this.showOption) {
            this.valueCreator = value
            this.valueCreatorDeleted = undefined
            this.creatorId = id
            this.styleVisibility = { visibility: 'visible' }
            this.hidenModal()
            this.markChanged()
        }
    }

    // search language
    searchStaff(): void {
        const term = this.filterStaff
        this.arrStaff = this.optionArrCopy.filter(function(tag) {
            return tag.firstName && tag.firstName.indexOf(term) >= 0 || tag.familyName && tag.familyName.indexOf(term) >= 0
        })
    }

    selectOptionStaff(id, value) {
        this.showOptionStaff = 'showOption_' + id
        if (this.showOptionStaff) {
            this.valueStaff = value
            this.valueStaffDeleted = undefined
            this.StaffId = id
            this.styleVisibilityStaff = { visibility: 'visible' }
            this.hidenModal()
            this.markChanged()
        }
    }

    // search language
    search(): void {
        const term = this.filterLang
        this.arrUser = this.optionArrCopy.filter(function(tag) {
            return tag.firstName && tag.firstName.indexOf(term) >= 0 || tag.familyName && tag.familyName.indexOf(term) >= 0
        })
    }

    // get list user
    listUser() {
        if (this.statusReadonly) {
            return
        }
        this.hiddenModalUser = 'active'
        this.statusESC = true
        const resourceUrl = 'resource'
        const resourceData = this.restApi.makeResourceObject({
            status: {
                NewRomm: {
                    paths: {
                        '{}': true,
                    },
                },
            },
        })
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.arrUser = success['response']['staff']['searches']["{\"deleted\": {\"$ne\": true}}"]
                this.optionArrCopy = this.arrUser.slice() // copy of optionArr
                if (this.arrUser) {
                    this.arrUser.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                }
            })
        })
    }

    listStaff() {
        if (this.statusReadonly) {
            return
        }
        this.hiddenModalUserStaff = 'active'
        this.statusESC = true
        const resourceUrl = 'resource'
        const resourceData = this.restApi.makeResourceObject({
            status: {
                NewRomm: {
                    paths: {
                        '{}': true,
                    },
                },
            },
        })
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.arrStaff = success['response']['staff']['searches']["{\"deleted\": {\"$ne\": true}}"]
                this.optionArrCopy = this.arrStaff.slice() // copy of optionArr
                if (this.arrStaff) {
                    this.arrStaff.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                }
            })
        })
    }

    private validationOnClose() {
        switch (this.showModal) {
            case this.TYPE_MODAL_POPUP.VIDEO:
                if (!this.checkHasValidator) {
                    this.showMessage = 'This field is required'
                    return false
                }
                break
            case this.TYPE_MODAL_POPUP.PDF:
                if (!this.checkHasValidator) {
                    this.showMessage = 'This field is required'
                    return false
                }
                break
            case this.TYPE_MODAL_POPUP.IMAGE:
                if (!this.checkHasValidator) {
                    this.showMessage = 'This field is required'
                    return false
                }
                break
            case this.TYPE_MODAL_POPUP.MESSAGE:
                if (this.noteMessage.length <= 0) {
                    this.showMessage = 'This field is required'
                    return false
                }
                break

        }
        return true
    }

    private resetValidationValue() {
        this.checkHasValidator = false
        this.showMessage = ''
    }

    // save message
    saveMessage(statusSave) {
        if (!this.validationOnClose()) {
            return
        }
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: '<b>' + this.en['alert-save'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        if (statusSave === 'edit') {
                            this.sendMessageRequest('update')
                        } else {
                            this.sendMessageRequest('create')
                        }
                        this.resetValidationValue()
                    }
                },
            })
        } else {
            this.showEditMessage = 'hidden'
            this.resetModel()
        }
    }

    sendMessageRequest(type) {
        const clientId = {}
        clientId['{"clientId":"' + this.idRoom + '"}'] = true
        const resourceData = this.restApi.makeResourceObject({
            actions: [{
                type: type,
                id: type == 'create' ? null : this.idUpdateTimeline,
                collection: 'clientCommunication',
                value: {
                    note: this.noteMessage,
                    // next: this.nextMessage,
                    clientId: this.idRoom, doctor: this.creatorId, staff: this.StaffId, tags: this.selectedTags,
                    type: 'message',
                },
            }], status: {
                clientCommunication: {
                    paths: clientId, searches: clientId,
                },
            },
        })
        this.notificationServices.performPushNotification(this.idRoom)

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showEditMessage = 'hidden'
                const listTimeline = success['response']['clientCommunication']['searches']['{"clientId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)
                this.resetModel()
            })
        })
    }

    markChanged() {
        if (this.hasBeenLoaded) {
            this.hasBeenEdited = true
        }
    }

    // *********************************************************** *************************MODAL IMAGE **********************************************************************//
    allowDrop(e) {
        e.preventDefault()
    }

    drop(e, i) {
        e.preventDefault()
        this.markChanged()

        this.handleFileInput(e.dataTransfer.files, e, i)
    }

    dropPdf(e, i) {
        e.preventDefault()
        this.markChanged()
        this.handleFilePdfInput(e.dataTransfer.files, e, i)
    }

    handleFileInput(files: FileList, event, startIndex) {
        console.debug('handleFileInput', files)
        this.showMessage = ''
        if (files && files[0]) {
            let fileNum = 0
            if (this.statusSave == 'edit' && this.arrclientId && this.arrclientId['images'] && this.arrclientId['images'].length > 0) {
                if (this.matrixServices.arrFlip.length < this.arrclientId['images'].length) {
                    this.initArrayMatrix(this.arrclientId['images'])
                }
            }

            this.authData.authToken().then(tokenReNew => {
                let idx
                const fileCount = files.length
                for (idx = 0; idx < fileCount; idx++) {
                    const file = files[idx]

                    if (file && file['type'] === 'image/jpeg' || file['type'] === 'image/png' || file['type'] === 'image/tiff') {
                        let i = startIndex + fileNum
                        this.isSaveImage = true
                        if (!this.arrImage[i]) {
                            this.addImage(event, false)
                        }

                        let reader = new FileReader()
                        reader.readAsDataURL(file) // read file as data url

                        reader.onload = (event: any) => { // called once readAsDataURL is completed
                            this.url = event.target.result
                            // this.arrstatusImage.splice(i, 1, i);
                            this.statusImage = true
                            // this.arrLoading.push(true);
                            this.arrLoading.splice(i, 1, true)
                            this.animationDuration = 2800
                        }
                        this.checkHasValidator = true
                        this.loading = true
                        this.statusShowImage.splice(i, 1, true)
                        const subscription = this.restApi.postFile(file, tokenReNew).subscribe(success => {
                            this.unsubscribePostFile(i)
                            this.matrixImage.splice(i, 1, [1, 0, 0, 1])
                            const hashUrl = success['hash']
                            const idImage = {
                                id: hashUrl, matrix: this.matrixImage[i],
                            }

                            // this.matrixServices.arrImageHash.splice(i, 1, idImage);
                            this.arrImageHash.splice(i, 1, idImage)
                            const url = imageUrl + hashUrl

                            this.arrImage.splice(i, 1, url)
                            this.arrLoading.splice(i, 1, false)
                            this.statusShowImage.splice(i, 1, false)
                            this.isSaveImage = false
                        })

                        this.postFileSubs[i] = subscription
                        fileNum++
                    }
                }

                this.reset()
            })

        }
    }

    handleFilePdfInput(files: FileList, event, i) {
        console.debug('handleFilePdfInput', files)
        this.showMessage = ''
        if (files && files[0]) {
            const file = files[0]
            if (file['type'] === 'application/pdf') {
                const reader = new FileReader()
                reader.readAsDataURL(file) // read file as data url
                this.isSavePdf = true
                reader.onload = (event: any) => { // called once readAsDataURL is completed
                    this.url = event.target.result
                    // this.arrstatusImage.splice(i, 1, i);
                    this.statusPdf = true
                    // this.arrLoading.push(true);
                    this.arrLoading.splice(i, 1, true)
                    this.animationDuration = 2800
                }
                this.checkHasValidator = true
                this.loading = true
                this.statusShowPdf.splice(i, 1, true)
                this.authData.authToken().then(tokenReNew => {
                    const subscription = this.restApi.postFile(file, tokenReNew).subscribe(success => {
                        this.unsubscribePostFile(i)
                        const hashUrl = success['hash']
                        const idPdf = {
                            id: hashUrl,
                            name: file.name,
                        }
                        // this.matrixServices.arrImageHash.splice(i, 1, idImage);
                        this.arrPdfHash.splice(i, 1, idPdf)
                        const url = imageUrl + hashUrl

                        this.arrPdf.splice(i, 1, url)
                        this.arrLoading.splice(i, 1, false)
                        this.statusShowPdf.splice(i, 1, false)
                        this.isSavePdf = false
                    })
                    this.postFileSubs[i] = subscription
                })
            }
        }
        this.displayRemovePdf = false
    }

    // *********************************************************** *************************MODAL VIDEO **********************************************************************//

    handleFileInputVideo(files: FileList, event, i) {        
        console.debug('handleFileInputVideo', files)
        const file = files[0]
        this.showMessage = ''
        if (file && file['type'].search('video/') > -1) {
            if (file['size'] / 1024 / 1024 > 256) {
                notification.confirm({
                    message: this.en['communication-video-max-upload-size-exceeded'],
                    title: '<b>' + this.en['alert-title'] + '</b>',
                    cancelable: false,
                    buttonLabels: ['OK'],
                })
                $('#inputVideo' + i).val('')
            } else {
                const reader = new FileReader()
                this.isSaveVideo = true
                reader.readAsDataURL(file) // read file as data url

                reader.onload = (event: any) => { // called once readAsDataURL is completed
                    this.url = event.target.result
                    this.arrstatusVideo.splice(i, 1, i)
                    this.statusVideo = true
                    // this.arrLoading.push(true);
                    this.arrLoading.splice(i, 1, true)
                    this.animationDuration = 3500
                }
                this.checkHasValidator = true
                this.statusShowImage.splice(i, 1, true)
                this.authData.authToken().then(tokenReNew => {
                    const subscription = this.restApi.postFile(files.item(0), tokenReNew).subscribe((success) => {
                        this.urlThumbail = getThumbnail(success['hash'])
                        this.unsubscribePostFile(i)
                        this.faceVideo = success['hash']
                        const idVideo = {
                            id: this.faceVideo,
                        }
                        this.reset()
                        this.arrVideoHash.splice(i, 1, idVideo)
                        this.url = imageUrl + success['hash']
                        this.arrVideo.splice(i, 1, this.url)
                        this.arrLoading.splice(i, 1, false)
                        this.statusShowImage.splice(i, 1, false)
                        this.isSaveVideo = false
                    }, error => {
                        console.error(error)
                        this.reset()
                        if (error.status === 413) {
                            this.showError(this.en['communication-video-max-upload-size-exceeded'])
                        } else {
                            this.showError(error.statusText)
                        }
                    })

                    this.postFileSubs[i] = subscription
                })
            }
        }
    }

    dropVideo(e, i) {
        event.preventDefault()
        this.markChanged()
        this.handleFileInputVideo(e.dataTransfer.files, e, i)
    }

    private unsubscribePostFile(index) {
        if (this.postFileSubs[index]) {
            this.postFileSubs[index].unsubscribe()
            delete this.postFileSubs[index]
        }
    }

    private showError(message) {
        notification.confirm({
            message: message,
            title: '<b>' + this.en['alert-title'] + '</b>',
            cancelable: false,
            buttonLabels: ['OK'],
        })
    }

    removeMovie(i) {
        console.debug('removeMovie', i)
        this.unsubscribeFile(i)
        this.checkHasValidator = false
        $('#inputVideo' + i).val('')
        this.urlThumbail = ''
        this.arrLoading[i] = false
        this.arrVideo.splice(i, 1, undefined)
        this.arrVideoHash.splice(i, 1, undefined)
        this.statusShowImage.splice(i, 1, false)
        // this.isSaveVideo = true
    }

    sendVideoRequest(type) {
        const clientId = {}
        clientId['{"clientId":"' + this.idRoom + '"}'] = true
        const resourceData = this.restApi.makeResourceObject({
            actions: [{
                type: type,
                id: type == 'create' ? null : this.idUpdateTimeline,
                collection: 'clientCommunication',
                value: {
                    note: this.noteMessage, clientId: this.idRoom,
                    staff: this.StaffId, video: compact(this.arrVideoHash), type: 'video', tags: this.selectedTags,
                },
            }], status: {
                clientCommunication: {
                    paths: clientId, searches: clientId,
                },
            },
        })
        this.notificationServices.performPushNotification(this.idRoom)
        delete resourceData.status.clinic

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showNewVideo = 'hidden'
                const listTimeline = success['response']['clientCommunication']['searches']['{"clientId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)
                this.resetModel()
            })
        })
    }

    pauseVid(event, pause) {
        const video = event.target
        if (pause) {
            video.play()
            this.pauseVideo = false
        } else {
            video.pause()
            this.pauseVideo = true
        }
    }

    downloadMovie(i) {
        const tmp = getImageStatusUrl(this.arrVideoHash[i]['id'])
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_get(tmp, tokenReNew).subscribe(res => {
                this.arrLoading[i] = true
                this.animationDuration = 4000
                var xhr = new XMLHttpRequest()
                xhr.open('GET', res['url'], true)
                xhr.responseType = 'blob'
                const _thi = this

                xhr.onprogress = function(event) {
                    if (event.lengthComputable) {
                        var percentComplete = (event.loaded / event.total) * 100
                        console.log(percentComplete)
                        // console.log(event.loaded);
                    }
                }
                console.log(this.arrVideoHash[i]['id'])
                xhr.onload = function(event) {
                    if (this != undefined && this['status'] != undefined && this['status'] == 200) {
                        _thi.saveBlob(this['response'], _thi.arrVideoHash[i]['id'], i)
                    }
                    xhr.abort()
                }

                xhr.send()
            })
        })
    }

    saveBlob(response, fileName, index) {
        if (navigator.msSaveBlob) {
            //OK for IE10+
            navigator.msSaveBlob(response, fileName)
        } else {
            this.html5Saver(response, fileName, index)
        }
    }

    html5Saver(blob, fileName, index) {
        this.changeLanguage()
        var a = document.getElementById('download')
        document.body.appendChild(a)
        var url = window.URL.createObjectURL(blob)
        a.setAttribute('href', url)
        a.setAttribute('download', fileName)
        this.arrLoading[index] = false
        notification.confirm({
            message: this.en['download-notice'],
            title: `<b>${ this.en['download'] }</b>`,
            buttonLabels: ['OK'],
            callback: i => {
                if (i === 0) {  // here this is not cancelled.  1 is correct.
                    a.click()
                }
            },
        })
    }

    addImage(event, resetInput = true) {
        if (this.arrImage[this.arrImage.length - 1] == 'init') {
            return
        }
        this.markChanged()
        if (resetInput)
            this.reset()
        this.arrImage.push('init')
        this.arrImageHash.push('init')
        this.arrLoading.push(false)
        this.matrixServices.arrStyleImage.push('')

        this.matrixImage.push([1, 0, 0, 1])
        // this.arrstatusImage.push(undefined);
        this.displayRemoveImage = false
        this.hiddeniconAddImage = false
        this.statusImage = false
        this.statusShowImage.push(false)
        // this.isSaveImage = true
    }

    addPdfFile() {
        console.log('addPdfFile')
        if (this.arrPdf[this.arrPdf.length - 1] == 'init') {
            return
        }
        this.markChanged()
        this.reset()
        this.arrPdf.push('init')
        this.arrPdfHash.push('init')
        // this.arrstatusImage.push(undefined);
        this.displayRemovePdf = false
        this.hiddeniconAddPdf = false
        this.statusPdf = false
        this.statusShowPdf.push(false)
        this.arrLoading.push(false)
        // this.isSavePdf = true
    }

    removeImage(index) {
        this.unsubscribeFile(index)

        this.markChanged()
        // this.isSaveImage = false
        this.arrStyleImage = this.matrixServices.arrStyleImage
        this.arrFlip = this.matrixServices.arrFlip
        this.arrImage.splice(index, 1)
        this.arrImageHash.splice(index, 1)
        if (this.arrImage.length === 0) {
            this.resetImageArr()
            this.displayRemoveImage = true
            // this.isSaveImage = true
        } else {
            if (this.arrImage.includes('init')) {
                // this.isSaveImage = true
                this.displayRemoveImage = true
            }
        }
        this.arrStyleImage.splice(index, 1)
        this.arrLoading.splice(index, 1, false)
        this.arrFlip.splice(index, 1)
        this.matrixServices.arrRotate.splice(index, 1)
        if (this.matrixServices.arrImage.length > this.arrImage.length) {
            this.matrixServices.arrImage.splice(index, 1)
            this.matrixServices.arrImageHash.splice(index, 1)

        }
        this.statusShowImage.splice(index, 1, false)

        // if (this.matrixServices.arrStyleImage.length > this.matrixServices.arrImage.length) {
        //     this.matrixServices.arrStyleImage.splice(index, 1);
        // }
        // this.matrixServices.arrStyleImage.splice(index, 1);
    }

    removePdf(index) {
        this.unsubscribeFile(index)
        this.markChanged()
        // this.isSavePdf = false
        this.arrPdf.splice(index, 1)
        this.arrPdfHash.splice(index, 1)
        if (this.arrPdf.length === 0) {
            this.arrPdf.push('init')
            this.displayRemovePdf = true
            // this.isSavePdf = true
        } else {
            if (this.arrPdf.includes('init')) {
                // this.isSavePdf = true
                this.displayRemovePdf =true
            }
        }
        this.statusShowPdf.splice(index, 1, false)
        this.arrLoading.splice(index, 1, false)
    }

    saveImage(statusSave) {
        // if (this.arrImage[0] === 'init') {
        //     this.checkHasValidator = false
        // }
        // if (!this.validationOnClose()) {
        //     return
        // }

        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: '<b>' + this.en['alert-save'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i != -1) {
                        if (i === 1) {  // here this is not cancelled.  1 is correct.
                            this.matrixImage = this.matrixServices.matrixImage
                            this.arrImageHash = this.matrixServices.arrImageHash
                            this.arrImage = this.matrixServices.arrImage
                            if (this.arrImage.length == 0) {
                                this.resetImageArr()
                            }
                            if (statusSave === 'edit') {
                                this.sendImageRequest('update')
                            } else {
                                this.sendImageRequest('create')
                            }
                            this.resetValidationValue()
                        }
                    }
                },
            })
        } else {
            this.resetModel()
            this.showNewImage = 'hidden'
        }
    }

    savePdf(statusSave) {
        if (this.arrPdf[0] == 'init') {
            this.checkHasValidator = false
        }
        if (!this.validationOnClose()) {
            return
        }
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: '<b>' + this.en['alert-save'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i != -1) {
                        if (i === 1) {  // here this is not cancelled.  1 is correct.
                            if (this.arrPdfHash.length == 0) {
                                this.arrPdfHash.push('init')
                            }
                            if (statusSave === 'edit') {
                                this.sendPdfRequest('update')
                            } else {
                                this.sendPdfRequest('create')
                            }
                            this.resetValidationValue()
                        }
                    }
                },
            })
        } else {
            this.resetModel()
            this.showNewPdf = 'hidden'
        }
    }

    saveVideo(statusSave) {
        if (!this.validationOnClose()) {
            return
        }
        this.changeLanguage()
        if (this.hasBeenEdited) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: '<b>' + this.en['alert-save'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        if (statusSave === 'edit') {
                            this.sendVideoRequest('update')
                        } else {
                            this.sendVideoRequest('create')
                        }
                        this.resetValidationValue()
                    }
                },
            })
        } else {
            this.showNewVideo = 'hidden'
            this.resetModel()
        }
    }

    sendImageRequest(type) {
        this.arrImageHash = this.arrImageHash.filter((item) => {
            return item !== 'init'
        })
        const clientId = {}
        clientId['{"clientId":"' + this.idRoom + '"}'] = true

        const resourceData = this.restApi.makeResourceObject({
            actions: [{
                type: type,
                id: type == 'create' ? null : this.idUpdateTimeline,
                collection: 'clientCommunication',
                value: {
                    note: this.noteMessage, clientId: this.idRoom,
                    staff: this.StaffId, images: compact(this.arrImageHash), type: 'image', tags: this.selectedTags,
                },
            }], status: {
                clientCommunication: {
                    paths: clientId, searches: clientId,
                },
            },
        })
        this.notificationServices.performPushNotification(this.idRoom)

        delete resourceData.status.clinic

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showNewImage = 'hidden'
                const listTimeline = success['response']['clientCommunication']['searches']['{"clientId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)
                this.resetModel()
                this.matrixServices.resetMatrix()
            })
        })
    }

    sendPdfRequest(type) {
        const clientId = {}
        clientId['{"clientId":"' + this.idRoom + '"}'] = true
        const resourceData = this.restApi.makeResourceObject({
            actions: [{
                type: type,
                id: type == 'create' ? null : this.idUpdateTimeline,
                collection: 'clientCommunication',
                value: {
                    note: this.noteMessage, clientId: this.idRoom,
                    staff: this.StaffId, pdfs: compact(this.arrPdfHash), type: 'pdf', tags: this.selectedTags,
                },
            }], status: {
                clientCommunication: {
                    paths: clientId, searches: clientId,
                },
            },
        })
        this.notificationServices.performPushNotification(this.idRoom)
        delete resourceData.status.clinic

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showNewPdf = 'hidden'
                const listTimeline = success['response']['clientCommunication']['searches']['{"clientId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)
                this.resetModel()
            })
        })
    }

    // ****************************************************************** EDIT MESSAGE ***************************************************** //
    getClientId(idRoom) {
        const resourceUrl = 'resource'
        const clientId = {}
        clientId['{"clientId":"' + this.idRoom + '"}'] = true
        const map = {}
        map[idRoom] = true
        const resourceData = this.restApi.makeResourceObject({
            status: {
                clientCommunication: {
                    map, paths: clientId, searches: clientId,
                },
            },
        })
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {

                this.arrclientId = success['response']['clientCommunication']['map'][idRoom]
                if (this.arrclientId['type'] == 'image') {
                    this.initArrayMatrix(this.arrclientId['images'])
                } else if (this.arrclientId['type'] == 'pdf') {
                    this.initPdfs(this.arrclientId['pdfs'])
                } else if (this.arrclientId['type'] == 'video') {
                    this.initVideo(this.arrclientId['video'])
                }
                this.noteMessage = this.arrclientId['note']
                // this.nextMessage = this.arrclientId['next']
                this.showDate = this.arrclientId['updateTime']
                const staff = success['response']['staff']['paths']['{}']
                for (let i = 0; i <= staff.length; i++) {
                    if (staff[i] && staff[i]['_id'] === this.arrclientId.doctor) {
                        this.valueCreator = (staff[i].firstName || '') + ' ' + (staff[i].familyName || '')
                        this.valueCreatorDeleted = staff[i].deleted
                    }
                    if (staff[i] && staff[i]['_id'] === this.arrclientId.staff) {
                        this.valueStaff = (staff[i].firstName || '') + ' ' + (staff[i].familyName || '')
                        this.valueStaffDeleted = staff[i].deleted
                    }
                }
                this.creatorId = this.arrclientId.doctor
                this.StaffId = this.arrclientId.staff

                this.selectedTags = this.arrclientId['tags'] ? this.arrclientId['tags'] : []
                setTimeout(() => {
                    // this.loading = false;
                    if (this.arrLoading.length) {
                        for (let a = 0; a < this.arrLoading.length; a++) {
                            this.arrLoading.splice(a, 1, false)
                        }
                    }
                }, 500)
                return this.arrclientId
            })
        })
        return {}
    }

    initPdfs(arrayPdfs: any[] = []) {
        this.arrPdfHash = []
        this.arrPdf = []
        this.arrLoading = []
        this.displayRemovePdf = false

        const tpmArrPdfHash: any[] = []
        const tmpArrPdf: any[] = []

        if (arrayPdfs && arrayPdfs.length > 0) {
            arrayPdfs.forEach((el, i) => {
                tpmArrPdfHash.push(el)
                if (el && el['id']) {
                    this.url = imageUrl + el['id']
                    tmpArrPdf.push(this.url)
                } else {
                    tmpArrPdf.push('init')
                }
                this.arrLoading.push(false)
            })
            this.arrPdfHash = jQuery.extend(true, [], tpmArrPdfHash)
            this.arrPdf = jQuery.extend(true, [], tmpArrPdf)
            this.checkHasValidator = true
        }

        if (this.arrPdf.length === 0) {
            this.arrPdf.push('init')
            this.displayRemovePdf = true
        }
    }

    initVideo(arrayVideos: any[] = []) {
        this.arrVideoHash = []
        this.arrVideo = []
        this.arrLoading = []
        this.displayRemoveVideo = false

        const tpmArrVideoHash: any[] = []
        const tmpArrVideo: any[] = []

        if (arrayVideos && arrayVideos.length > 0) {
            arrayVideos.forEach((el) => {
                tpmArrVideoHash.push(el)
                if (el && el['id']) {
                    this.url = el['id']
                    tmpArrVideo.push(this.url)
                }
                this.arrLoading.push(false)
            })
            this.arrVideoHash = jQuery.extend(true, [], tpmArrVideoHash)
            this.arrVideo = jQuery.extend(true, [], tmpArrVideo)
            this.checkHasValidator = true
        }

        if (this.arrVideo.length === 0) {
            this.arrVideo.push('init')
            this.displayRemoveVideo = true
        }
    }

    compactString(str) {
        const max = 30
        str = str.replace('.pdf', '')
        return str.length > max ? str.substring(0, max) + '... .pdf' : str + '.pdf'
    }

    initArrayMatrix(arrayGeneral: any[] = []) {
        this.animationDuration = 300
        this.displayRemoveImage = false
        this.arrImageHash = []
        this.arrImage = []
        //matrix
        this.matrixImage = []
        const matrix = [1, 0, 0, 1]
        const arrRotate: any[] = []
        const arrStyleImage: any[] = []
        const arrFlip: any[] = []
        const jsonFlip: any = {}
        jsonFlip['horizontalFlip'] = 1
        jsonFlip['verticalFlip'] = 1
        this.arrLoading = []
        const tpmArrImageHash: any[] = []
        const tmpArrayMatrixImage: any[] = []
        const tmpArrImage: any[] = []
        const dxdyMatrix: any[] = []

        if (arrayGeneral && arrayGeneral.length > 0) {
            arrayGeneral.forEach((el) => {
                if (el) {
                    if (el && el['matrix']) {
                        tmpArrayMatrixImage.push(el['matrix'])
                    } else {
                        tmpArrayMatrixImage.push(matrix)
                    }
                    tpmArrImageHash.push(el)
                    if (el && el['id']) {
                        this.url = imageUrl + el['id']
                        tmpArrImage.push(this.url)
                    }
                    // this.arrImageHash.push({});
                    arrRotate.push(0)
                    arrStyleImage.push('')
                    arrFlip.push(jsonFlip)
                    dxdyMatrix.push(0)
                    // this.arrayMatrixImage.push(matrix);
                    this.arrLoading.push(false)
                }
            })
            this.matrixImage = jQuery.extend(true, [], tmpArrayMatrixImage)
            this.arrImageHash = jQuery.extend(true, [], tpmArrImageHash)
            this.arrImage = jQuery.extend(true, [], tmpArrImage)

            if (this.matrixServices.arrFlip.length < arrFlip.length) {
                this.matrixServices.arrImage = jQuery.extend(true, [], this.arrImage)
                this.matrixServices.matrixImage = jQuery.extend(true, [], this.matrixImage)
                this.matrixServices.arrImageHash = jQuery.extend(true, [], this.arrImageHash)
                this.matrixServices.arrRotate = jQuery.extend(true, [], arrRotate)
                this.matrixServices.arrStyleImage = jQuery.extend(true, [], arrStyleImage)
                this.matrixServices.arrFlip = jQuery.extend(true, [], arrFlip)
                this.matrixServices.dXdYMatrixCanvas = jQuery.extend(true, [], dxdyMatrix)
            }
            this.checkHasValidator = true
        }
        if (this.arrImage.length === 0) {
            this.resetImageArr()
            this.displayRemoveImage = true
        }
    }

    // ************************************************************* REMOVE TIMELINNE ************************************************************ //
    removeTimeline(idTimeLine) {
        this.changeLanguage()
        notification.confirm({
            message: this.en['alert-content-2'],
            title: '<b>' + this.en['alert-remove'] + '</b>',
            cancelable: true,
            buttonLabels: [this.en['alert-cancel'], 'OK'],
            callback: i => {
                if (i === 1) {  // here this is not cancelled.  1 is correct.
                    this.removeTimelineId(idTimeLine)
                }
            },
        })
    }

    removeTimelineId(idTimeLine) {
        const clientId = {}
        clientId['{"clientId":"' + this.idRoom + '"}'] = true
        const resourceData = this.restApi.makeResourceObject({
            actions: [{
                type: 'remove', id: idTimeLine, collection: 'clientCommunication',
            }], status: {
                clientCommunication: {
                    paths: clientId, searches: clientId,
                },
            },
        })
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.showEditMessage = 'hidden'
                this.showNewImage = 'hidden'
                this.showNewPdf = 'hidden'
                const listTimeline = success['response']['clientCommunication']['searches']['{"clientId":"' + this.idRoom + '"}']
                const arrTimeline = ['loadTimelineNew', listTimeline]
                this._sharedService.emitChange(arrTimeline)
                this.resetModel()
            })
        })
    }

    resetModel() {
        this.resetValidationValue()
        this.urlThumbail = ''
        this.noteMessage = undefined
        this.creatorId = undefined
        this.valueCreator = undefined
        this.valueCreatorDeleted = undefined
        this.StaffId = undefined
        this.valueStaff = undefined
        this.valueStaffDeleted = undefined
        this.showOption = undefined
        this.showOptionStaff = undefined
        this.arrPdf = ['init']
        this.statusSave = undefined
        this.matrixImage = []
        this.arrPdfHash = []
        this.arrFlip = []
        this.arrRotate = []
        this.arrLoading = []
        this.createDate = moment(Date.now())

        this.dXdYMatrixCanvas = []
        this.matrixServices.arrStyleImage = [];
        this.matrixServices.resetMatrix();
        this.arrVideoHash = []
        this.arrVideo = [undefined]
        this.showNewVideo = 'hidden'

        this.hasBeenEdited = false
        this.statusShowImage = []
        this.statusShowPdf = []
        this.resetImageArr()

        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe()
        })
        this.postFileSubs = {}
        this.loading = false
        this.displayRemoveImage = true
        this.displayRemovePdf = true
    }

    reset() {
        this.myInputVariable.nativeElement.value = ''
        this.loading = false
    }

    removePhoto(index) {
        console.debug('removePhoto', index)
        this.unsubscribeFile(index)
        this.arrImage.splice(index, 1, 'init')
        if (this.arrImage.length === 0) {
            this.resetImageArr()
            this.displayRemoveImage = true
        }
        this.arrImageHash.splice(index, 1, undefined)
        this.arrLoading.splice(index, 1, false)
        this.statusShowImage.splice(index, 1, false)
    }

    downloadPdf(event, id, name) {
        event.stopPropagation()

        this.authData.authToken().then(tokenReNew => {
            this.restApi.downloadFile(tokenReNew, id, name)
        })
    }

    resetImageArr() {
        this.arrImage = ['init']
        this.arrImageHash = ['init']
        this.arrStyleImage = []
        this.matrixServices.arrStyleImage = ['']
        this.matrixImage = [[1, 0, 0, 1]]
    }

    private unsubscribeFile(index = 0) {
        this.unsubscribePostFile(index)
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/communication/modal-communication-client-detail.component.ts